import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {AppAlertGqlModel} from "./app-alert.gql-model";

export interface AppAlertEditDialogInput {
  alert: AppAlertGqlModel;
}

export interface AppAlertEditDialogResult {
  save: boolean;
  alert: AppAlertGqlModel;
}

@Component({
  templateUrl: "./app-alert-edit-dialog.template.pug",
})
export class AppAlertEditDialogComponent
  extends DialogComponent<AppAlertEditDialogInput, AppAlertEditDialogResult>
  implements AppAlertEditDialogInput {
  id: string;
  alert: AppAlertGqlModel = new AppAlertGqlModel({});

  get header() {
    return this.alert.formGroup.get("header");
  }

  get text() {
    return this.alert.formGroup.get("text");
  }

  get priority() {
    return this.alert.formGroup.get("priority");
  }

  static show(dialogService: DialogService, alert?: AppAlertGqlModel): Promise<AppAlertEditDialogResult> {
    if (!alert) alert = new AppAlertGqlModel({});

    return dialogService.showDialog(AppAlertEditDialogComponent, {alert});
  }

  close() {
    this.result = {save: false, alert: this.alert};
    super.close();
  }

  save() {
    if (!this.alert.formGroup.valid) {
      return; // show validation
    }

    this.result = {save: true, alert: this.alert};
    super.close();
  }

  constructor(dialogService: DialogService) {
    super(dialogService);
  }
}
